import React, { useEffect, useState } from "react"
import { AnimatePresence, motion } from "framer-motion"
import styled from "@emotion/styled"
import TopNav from "../TopNav"
import NewFooter from "../NewFooter"
import { colors } from "../../styles"

const CurtainWrapper = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    pointer-events: none;
    z-index: 1000;

    .color-1,
    .color-2,
    .color-3 {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        transform-origin: top;
        will-change: transform;
    }

    .color-1 {
        z-index: 3;
        background-color: ${colors.transitionColor1};
    }

    .color-2 {
        z-index: 2;
        background-color: ${colors.transitionColor2};
    }

    .color-3 {
        z-index: 1;
        background-color: ${colors.transitionColor3};
    }
`

const ContentWrapper = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
`

const curtainVariant = {
  enter: { transition: { staggerChildren: 0.08 } },
  end: { transition: { staggerChildren: 0.05, staggerDirection: -1 } },
}

const colorVariant = {
  start: { scaleY: 1 },
  enter: { scaleY: 0, transition: { duration: 0.8, ease: "easeInOut" } },
  end: { scaleY: 1, transition: { duration: 0.5, ease: "easeInOut" } },
}

const contentVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.5, ease: "easeOut" } },
  exit: { opacity: 0, transition: { duration: 0.3, ease: "easeIn" } },
}

const TransitionCurtain = ({ children, location }) => {
  const [showChildren, setShowChildren] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)

    // Set background to transition color
    document.body.style.backgroundColor = colors.transitionColor1

    const timeout = setTimeout(() => {
      setShowChildren(true)
      // Smoothly transition to white
      document.body.style.backgroundColor = colors.white
    }, 800)

    return () => {
      clearTimeout(timeout)
      setShowChildren(false)
      document.body.style.backgroundColor = colors.white
    }
  }, [location?.pathname])

  return (
    <>
      <TopNav />

      <AnimatePresence mode="wait">
        <CurtainWrapper
          key={location?.pathname || "curtain"}
          initial="start"
          animate="enter"
          exit="end"
          variants={curtainVariant}
        >
          <motion.div variants={colorVariant} className="color-1" />
          <motion.div variants={colorVariant} className="color-2" />
          <motion.div variants={colorVariant} className="color-3" />
        </CurtainWrapper>
      </AnimatePresence>

      <ContentWrapper>
        <AnimatePresence mode="wait">
          {showChildren && (
            <motion.div
              key={location?.pathname || "page"}
              variants={contentVariants}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              {children}
            </motion.div>
          )}
        </AnimatePresence>
      </ContentWrapper>

      <NewFooter />
    </>
  )
}

export default TransitionCurtain
